import { Icon } from '@chakra-ui/react';

export default function SFSaveIconFilled(props) {
  return (
    <Icon
      width={3}
      height='18px'
      viewBox='0 0 12 18'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M1.5625 17.7266C1.03906 17.7266 0.734375 17.3828 0.734375 16.7734V3.21094C0.734375 1.72656 1.47656 0.96875 2.94531 0.96875H9.05469C10.5234 0.96875 11.2656 1.72656 11.2656 3.21094V16.7734C11.2656 17.3828 10.9609 17.7266 10.4375 17.7266C10.0547 17.7266 9.82812 17.5078 9.125 16.8281L6.07031 13.8203C6.03906 13.7812 5.96875 13.7812 5.92969 13.8203L2.875 16.8281C2.17188 17.5078 1.94531 17.7266 1.5625 17.7266Z' />
    </Icon>
  );
}
